import { EstadosActivacionInstallOTEnumChoice, ROUTER_PATHS } from "@/shared";
import { useGetOrdenTrabajo } from "@/shared/actions/erp";
import { LoaderComponent } from "@/shared/components/ui";
import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom"
import SaveActivacionesVisitaPendingOT from "../../shared/components/SaveActivacionesVisitaPendingOT";
import { SystemModulesEnum } from "@/auth/interfaces";
import { hasSystemModule } from "@/shared/utils";

export default function ActivacionesVisitaGestionadaPage() {
    const { id } = useParams();
    const navigate = useNavigate();
    const { data, isLoading } = useGetOrdenTrabajo(id!)
    useEffect(() => {
        if (data?.data && data.data.estado_activacion !== EstadosActivacionInstallOTEnumChoice.GESTIONADA) {
            navigate(ROUTER_PATHS.activaciones.activacionesVisitaNav, { replace: true });
        }
    }, [data?.data])
    if (isLoading) return <LoaderComponent />
    if (!data?.data) return <LoaderComponent />
    return (
        <SaveActivacionesVisitaPendingOT
            titlePage="Activación de Visita Gestionada"
            ordenTrabajo={data.data}
            customReturnUrl={ROUTER_PATHS.activaciones.activacionesVisitaNav}
            canDeleteFotos={hasSystemModule(SystemModulesEnum.ACTIVACIONES_VISITA)}
        />
    )
}